if (!customElements.get('sokynd-cart-upsells')) {
  customElements.define('sokynd-cart-upsells', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-upsell-variant]');
        if (!select) return;
        const card = select.closest('.sokynd-cart-upsell-card');
        const option = select.selectedOptions[0];
        card.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const compare = card.querySelector('[data-upsell-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
      }, options);
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-upsell-add]');
        if (!button || button.disabled || this.pending) return;
        const card = button.closest('.sokynd-cart-upsell-card');
        const select = card.querySelector('[data-upsell-variant]');
        const variantId = select?.value || button.dataset.variantId;
        const status = this.closest('cart-form').querySelector('[data-sokynd-cart-status]');
        const originalLabel = button.textContent;
        this.pending = true;
        this.querySelectorAll('[data-upsell-add]').forEach((add) => { add.disabled = true; });
        button.textContent = this.dataset.adding;
        status.textContent = '';
        const hook = this.waitForCartHook(variantId);
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || this.dataset.error);
          await hook.promise;
          status.textContent = '';
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        } catch (error) {
          hook.finish();
          status.textContent = error.message || this.dataset.error;
        } finally {
          this.pending = false;
          this.querySelectorAll('[data-upsell-add]').forEach((add) => { add.disabled = false; });
          button.textContent = originalLabel;
        }
      }, options);
    }
    waitForCartHook(variantId) {
      let complete;
      const promise = new Promise((resolve) => { complete = resolve; });
      const finish = () => {
        clearTimeout(timeout);
        window.removeEventListener('SCE:add', receive);
        complete();
      };
      const receive = (event) => {
        if (String(event.detail?.variant_id) === String(variantId)) finish();
      };
      const timeout = setTimeout(finish, 1200);
      window.addEventListener('SCE:add', receive);
      return { promise, finish };
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
